const defaults = {
    walletLectureBonusInit: false,
    walletChannelBonusInit: false,
    walletRelayBonusInit: false,
};

export default (state = defaults, action) => {
    switch (action.type) {
    case 'WALLET_LECTURE_BONUS_INIT':
        return {
            ...state,
            walletLectureBonusInit: true,...action.payload,
            lectureBonusList: [...action.payload.lectureBonus.data]
        };
    case 'WALLET_LECTURE_BONUS_LOAD_MORE':
        return {
            ...state,
            walletLectureBonusInit: true, ...action.payload,
            lectureBonusList: [...state.lectureBonusList, ...action.payload.lectureBonus.data]
        };

    case 'WALLET_CHANNEL_BONUS_INIT':
        return {
            ...state,
            walletChannelBonusInit: true, ...action.payload,
            channelBonusList: [...action.payload.channelBonus.data]
        };
    case 'WALLET_CHANNEL_BONUS_LOAD_MORE':
        return {
            ...state,
            walletChannelBonusInit: true, ...action.payload,
            channelBonusList: [...state.channelBonusList, ...action.payload.channelBonus.data]
        };

    case 'WALLET_RELAY_BONUS_INIT':
        return {
            ...state,
            walletRelayBonusInit: true,...action.payload,
            relayBonusList: [...action.payload.relayBonus.data]
        };
    case 'WALLET_RELAY_BONUS_LOAD_MORE':
        return {
            ...state,
            walletRelayBonusInit: true, ...action.payload,
            relayBonusList: [...state.relayBonusList, ...action.payload.relayBonus.data]
        };

    case 'WALLET_BONUS_PAGE_UNMOUNT':
        return {
            ...state,
            walletLectureBonusInit: false,
            walletChannelBonusInit: false,
            walletRelayBonusInit: false
        };
    default:
        return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/walletExtensionIncome.js